<template>
  <div id="app" :style="{
    '--theme': verConfig.theme,
    '--navTheme': verConfig.navTheme,
    '--bg': '#fff',
    '--grey': '#b8ecff',
    '--gold': '#deb86b',
    '--black': '#000',
    '--navBg': '#c9b178',
    '--moduleColor': '#262626',
    '--hallBg': '#000',
    '--yellow': '#c9b178',
    '--light': '#fff',
    '--main_bg': '#fff',
    '--btn_bg': 'linear-gradient(90deg, #bead6e, #99793a)',
  }">
    <router-view />
    <WelfareDialog v-model="welfareDialogShow" :content="welfareDialogContent" :msgId="messageInfo.id" @read="read"
      :next="nextmsg" :clickOverlay="false" backgroundImage="'./assets/home/dialog_bg.png'" />
  </div>
</template>
<script>
import { Tabbar, TabbarItem, Toast } from "vant";
import WelfareDialog from "@/components/welfareDialog.vue";
import { GET_UNREAD_MESSAGES } from "@tt/api";
import {
  generateRandomString,
  baseEncode,
  setCookieValue,
  getCookieValue,
} from "@/utils/common";
export default {
  data() {
    return {
      welfareDialogShow: false,
      welfareDialogContent: "",
      messageInfo: {},
      msgList: [],
      nextmsg: false,
    };
  },
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    WelfareDialog,
  },
  created() {
    this.$store.dispatch("getCountry");
    this.$store.dispatch("getList");
    
    if (!getCookieValue("channel")) {
      setCookieValue("channel", baseEncode());
    }
    // if (!localStorage.getItem('user-info')) {
    //   if (this.$router.history.current.name !== 'login') {
    //     // this.$router.replace('login')
    //     this.$router.push('/login')
    //   }
    // }
    // this.$store.dispatch("getSystemConfig");
    sessionStorage.setItem("version-dialog-show", true);
    if (!localStorage.getItem("version")) {
      localStorage.setItem("version", "1.0.7");
    }
  },
  computed: {
    ifShowTabbar() {
      let list = ["goods", "financing", "cart", "record", "user"];
      // console.log(list.includes(this.$router.history.current.name));
      return list.includes(this.$router.history.current.name);
    },
  },
  methods: {
    onChange() {
      // window.console.log(123);
    },
    goto(path = ``) {
      this.$router.push(`/${path}`);
    },
    read(next = false, nextParams = {}) {
      if (nextParams && Object.keys(nextParams).length)
        this.messageInfo = nextParams;
      // this.msgList.shift();
      if (!!this.msgList[0].nextmsg && !next) {
        this.welfareDialogContent = this.msgList[0].nextmsg;
        if (!next) {
          this.nextmsg = true;
        } else {
          this.nextmsg = false;
        }
        this.welfareDialogShow = true;
      }
      // if (this.msgList.length) {
      //   this.welfareDialogContent = this.msgList[0].content;
      //   this.messageInfo = this.msgList[0];
      //   this.welfareDialogShow = true;
      // }
    },
    async getMessage() {
      // Toast.loading({ duration: 0 });
      try {
        const res = await GET_UNREAD_MESSAGES({
          perPage: 999,
          notify: 1,
          notify: 1,
        });
        Toast.clear();
        const { ret, msg, data } = res;
        if (!data.total) return;
        if (!!data.lists.length) {
          this.welfareDialogShow = true;
          if (!!this.messageInfo.id && this.messageInfo.id == data.lists[0].id)
            return;
          this.welfareDialogContent = data.lists[0].content;
          this.messageInfo = data.lists[0];
          this.msgList = data.lists;
        }
      } catch (error) {
        // console.log(error);
        Toast.clear();
      }
    },
  },
  watch: {
    $route(to, from) {
      const token = localStorage.getItem("token");
      if ((to.path === "/registrasi") | (to.path === "/login") | !token) return;
      this.getMessage();
    },
  },
};

window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
</script>
<style>
@import url("./assets/iconfonts/iconfont.css");

#app {
  width: 100%;
  height: 100%;
}

body {
  font-size: 16px;
  /* background-color: #fff; */
  background: var(--main_bg);
  -webkit-font-smoothing: antialiased;
  max-width: 648px;
  margin: 0 auto;
}

.van-nav-bar__placeholder,
.van-nav-bar {
  max-width: 648px;
  margin: 0 auto;
}

.van-nav-bar--fixed {
  left: auto !important;
}

a {
  position: fixed;
  top: -1000px;
}

.van-toast--loading {
  max-width: unset;
  min-height: unset;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  /* display:none */

}

.van-loading__spinner {
  margin: 0;
  width: 25px;
  height: 25px;

}
</style>
